<template>
  <div>
    <div class="order-load">
      <div class="load-left" v-if="orderData.status_buttons">
        <img
          class="load-img"
          :src="
            'https://static.dierqudao.com/images/icon-order-' +
            orderData.status_buttons.icon +
            '.png'
          "
          alt=""
          v-if="orderData.status_buttons.icon"
        />
        <div class="load-detail">
          <div class="order-load-title">
            {{ orderData.status_buttons.name }}
          </div>
          <div class="order-load-det">
            <van-count-down :time="lastTime" v-if="lastTime" />
            {{ orderData.status_buttons.note }}
          </div>
          <div class="order-button">
            <div
              class="header-btn success-btn"
              v-if="orderData.status_buttons.name == '待发货'"
              @click="toSend"
            >
              催发货
            </div>
            <div
              v-for="(button, index) in orderData.status_buttons.buttons"
              :class="'header-btn ' + button.class + '-btn'"
              @click="orderDo(button.type)"
            >
              {{ button.name }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="load-right">
                 订单跟踪<img class="icon-right" src="../assets/images/icon-right.png" alt="">
             </div>-->
    </div>
    <PayDialog
      scene="goods"
      :show="payShow"
      :ids="orderIds"
      @onPayError="onPayError"
      @onPaySuccess="onPaySuccess"
      @onPayClose="onPayClose"
    />
    <BookDialog
      :show="bookDialogShow"
      :wxNote="'订单' + orderData.code + '，' + book.note"
      :wxCode="book.wxcode"
      :wxPic="book.pic_url"
      :phone="book.phone"
      @onBookCancle="onBookCancle"
    ></BookDialog>
  </div>
</template>

<script>
import PayDialog from "@/components/PayDialog.vue";
import BookDialog from "@/components/BookDialog.vue";
import Vue from "vue";
import { Dialog, CountDown, Toast } from "vant";

Vue.use(CountDown).use(Dialog).use(Toast);

export default {
  name: "OrderDetailHeader",
  components: {
    PayDialog,
    BookDialog,
  },
  props: {
    orderData: {
      type: Object,
      default: {},
    },
    payShow: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      // payDialognameShow: this.payDialogShow,
      orderIds: [],
      lastTime: 0,
      bookDialogShow: false,
      book: {
        wxcode: "",
        pic_url: "",
        phone: "",
      },
    };
  },
  watch: {
    payShow(val) {
      if (!val) {
        this.orderIds = [];
      }
    },

    orderData(val) {
      let that = this;
      let lastTime = 0;

      if (val.book) {
        that.book = val.book;
      }

      if (val.status_buttons.buttons.length > 0) {
        lastTime = (val.status_buttons.buttons[0].last_time + 1) * 1000;
        // console.log(val.status_buttons.buttons)
      }
      that.watched(lastTime);
    },
  },
  methods: {
    watched(lastTime) {
      this.lastTime = lastTime;

      // console.log(lastTime);
    },

    toSend() {
      let that = this;
      let order_id = that.orderData.id;
      let time = new Date().getTime();
      // 判断是否已经通知
      let notice = JSON.parse(localStorage.getItem("order_" + order_id));
      if (!notice) {
        that.sendNotice(order_id, time);
        return;
      }

      // 存储localStorage 判断时间是否在24小时内
      if (time > notice.expire_time) {
        that.sendNotice(order_id, time);
      } else {
        Toast("已经帮您催过商家了, 24小时内只能催发货一次");
      }
    },

    sendNotice(order_id, time) {
      let that = this;
      that.$api.post(
        "/api/order/orderExpediting",
        { id: order_id },
        (res) => {
          Toast("已经通知商家尽快发货，请耐心等待");
          let data = {
            order_id: order_id,
            expire_time: time + 24 * 60 * 60 * 1000,
          };
          localStorage.setItem("order_" + order_id, JSON.stringify(data));
        },
        (res) => {
          Toast(res.msg);
        }
      );
    },

    orderDo(type) {
      let that = this;
      console.log(type);
      // console.log(that.orderData)

      switch (type) {
        case "pay":
          that.onPay();
          break;
        case "cancel":
          that.onCancel();
          break;
        case "serviceApply":
          that.onServiceApply();
          break;
        case "received":
          that.onReceived();
          break;
        case "book":
          that.onBook();
          break;
        case "toUse":
          // 核销
          that.onUse();
          break;
        case "serviceList":
          // 售后记录
          that.onServiceList();
          break;
        case "tuanShare":
          that.onTuanShare();
          break;

        case "jielongShare":
          that.onJielongShare();
          break;
        case "offline":
          that.onUpdateProof();
          break;
      }
    },

    onPay() {
      let that = this;
      that.orderIds = [that.orderData.id];
      this.$emit("payShowSuccess", that.orderIds);
    },

    // 确认收货
    onReceived() {
      let that = this;
      Dialog.confirm({
        title: "提示",
        message: "确定收货吗",
      })
        .then(() => {
          // on confirm
          console.log(that.orderData.id);
          that.$api.get(
            "/api/order/orderReceived",
            { id: that.orderData.id },
            (res) => {
              this.$emit("payShowClose");
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },

    // 预约
    onBook() {
      console.log("-----onBook----");
      this.bookDialogShow = true;
    },

    // 核销
    onUse() {
      let that = this;
      this.$router.push({
        path: "/orderuse",
        query: {
          order_id: that.orderData.id,
        },
      });
    },

    // 售后申请
    onServiceApply() {
      let that = this;
      this.$router.push({
        path: "/serviceapply",
        query: {
          order_id: that.orderData.id,
        },
      });
    },

    // 售后列表
    onServiceList() {
      let that = this;
      this.$router.push({
        path: "/serviceapplylist",
        query: {
          order_id: that.orderData.id,
        },
      });
    },

    onTuanShare() {
      let that = this;
      this.$router.push({
        path: "/tuanshare",
        query: {
          id: that.orderData.id,
        },
      });
    },

    onJielongShare() {
      let that = this;
      this.$router.push({
        path: "/jielongshare",
        query: {
          id: that.orderData.id,
        },
      });
    },
    onUpdateProof() {
      let that = this;
      rbLink({
          name:'OrderApplyBeizhu',
          query: {
          id: that.orderData.id,
        },
      })
      
    },

    onPayError() {
      this.$emit("payShoError");
    },

    onPaySuccess() {
      this.$emit("payShowClose");
    },

    onBookCancle() {
      this.bookDialogShow = false;
    },

    onPayClose() {
      this.$emit("payShowClose");
    },
  },

  filters: {},
};
</script>

<style scoped>
.order-load {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0.24rem;
}

.load-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.load-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 0.2rem;
}

.order-load-title {
  font-size: 18px;
  color: #333333;
  font-weight: 600;
  margin-top: 10px;
}

.van-count-down {
  font-size: 12px;
  line-height: 16px;
  color: #7b7b7b;
}

.order-load-det {
  font-size: 12px;
  color: #7b7b7b;
  margin: 0.1rem 0;

  display: flex;
  line-height: 16px;
}

.load-btn {
  width: 1.65rem;
  height: 0.48rem;
  line-height: 0.48rem;
  background: rgba(253, 40, 64, 1);
  border-radius: 0.06rem;
  text-align: center;
  font-size: 12px;
  color: #fff;
}

.load-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/*.header-btn {
        width: 82.5px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        color: #fff;
        background: rgba(253, 40, 64, 1);
        border-radius: 3px;
        font-size: 12px;
        padding: 0;
        margin: 0;
    }*/

.order-button {
  display: flex;
}

.normal-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  border-radius: 4px;
  /*border: 1px solid rgba(0, 0, 0, 1);*/
  border: 1px solid #ccc;

  margin-right: 15px;
  /*height:26px;
        line-height:26px;
        text-align:center;
        font-size: 12px;
        border-radius: 4px;
        margin-right: 15px;*/
}

.primary-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background: rgba(255, 0, 0, 1);
  border-radius: 4px;
  margin-right: 15px;
}

.success-btn {
  width: 75px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background: #07c160;
  border-radius: 4px;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// OrderDetailHeader.vue?2d4f45c1